import React, { useState } from "react";
import {
  Box,
  Typography,
  Paper,
  IconButton,
  Grid,
  Divider,
  Tooltip,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import { IoArrowBackOutline } from "react-icons/io5";
import { TbExternalLink } from "react-icons/tb";
import { Close, InsertPhoto, PictureAsPdf } from "@mui/icons-material";

const PRIMARY_COLOR = "#286a94";

function ViewCertificate({ setViewCer, data }) {
  const [openPdf, setOpenPdf] = useState(false);

  return (
    <Paper sx={{ p: 3, borderRadius: 3, boxShadow: 3 }}>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          mb: 2,
        }}
      >
        <IconButton
          onClick={() => setViewCer(false)}
          sx={{ color: PRIMARY_COLOR }}
        >
          <IoArrowBackOutline size={24} />
        </IconButton>
        <Typography variant="h6" fontWeight={600} color={PRIMARY_COLOR}>
          Certification Details
        </Typography>
      </Box>

      <Divider sx={{ mb: 3 }} />

      {/* Details Grid */}
      <Grid container spacing={2}>
        {[
          { label: "Certification ID", value: data.certificationId },
          { label: "Course Name", value: data.courseName },
          { label: "Duration", value: data.duration },
          { label: "Course Provider", value: data.courseProvider },
          { label: "Completion Year", value: data.year },
        ].map((item, index) => (
          <Grid item xs={12} sm={6} key={index}>
            <Typography
              variant="body2"
              sx={{ fontWeight: 600, color: "#6b7280" }}
            >
              {item.label}
            </Typography>
            <Typography
              variant="body1"
              sx={{ mt: 0.5, fontWeight: 500, color: "#111827" }}
            >
              {item.value || "N/A"}
            </Typography>
          </Grid>
        ))}

        {data?.certificationUrl && (
          <Grid item xs={12} sm={6}>
            <Typography
              variant="body2"
              sx={{ fontWeight: 600, color: "#6b7280" }}
            >
              Certificate Link
            </Typography>
            <Tooltip title="Open Certification URL">
              <IconButton
                href={data.certificationUrl}
                target="_blank"
                rel="noreferrer"
                sx={{ mt: 1, color: PRIMARY_COLOR }}
              >
                <TbExternalLink size={24} />
              </IconButton>
            </Tooltip>
          </Grid>
        )}

        {data?.certificateImageUrl &&
          data.certificateImageUrl.toLowerCase().endsWith(".pdf") && (
            <Grid item xs={12} sm={6}>
              <Typography
                variant="body2"
                sx={{ fontWeight: 600, color: "#6b7280", mb: 1 }}
              >
                Certificate File
              </Typography>

              <Button
                variant="outlined"
                startIcon={<PictureAsPdf />}
                onClick={() => setOpenPdf(true)}
                sx={{
                  color: PRIMARY_COLOR,
                  borderColor: PRIMARY_COLOR,
                  textTransform: "none",
                  fontWeight: 600,
                }}
              >
                View Certificate (PDF)
              </Button>
            </Grid>
          )}
      </Grid>

      {data?.certificateImageUrl &&
        !data?.certificateImageUrl.toLowerCase().endsWith(".pdf") && (
          <Box
            sx={{
              mt: 4,
              px: { xs: 1, sm: 2 },
            }}
          >
            {/* Section Header */}
            <Typography
              variant="h6"
              fontWeight={700}
              sx={{
                color: "#286a94",
                mb: 2,
              }}
            >
              Certificate
            </Typography>

            {/* Section Content */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "start",
              }}
            >
              <Box
                sx={{
                  p: 2.5,
                  borderRadius: 3,
                  background: "#f8fafc",
                  border: "1px solid #e5e7eb",
                  boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
                  maxWidth: 420,
                  width: "100%",
                  textAlign: "center",
                }}
              >
                <Box
                  component="img"
                  src={data.certificateImageUrl}
                  alt="Certificate"
                  sx={{
                    width: "100%",
                    borderRadius: 2,
                    objectFit: "contain",
                    transition: "transform 0.3s ease",
                    "&:hover": {
                      transform: "scale(1.02)",
                    },
                  }}
                />
              </Box>
            </Box>
          </Box>
        )}

      <Dialog
        open={openPdf}
        onClose={() => setOpenPdf(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle
          sx={{
            fontWeight: 700,
            color: "#286a94",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Certificate Preview
          <IconButton onClick={() => setOpenPdf(false)}>
            <Close />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers sx={{ p: 0 }}>
          <Box sx={{ height: "75vh" }}>
            <iframe
              src={data.certificateImageUrl}
              title="Certificate PDF"
              width="100%"
              height="100%"
              style={{ border: "none" }}
            />
          </Box>
        </DialogContent>
      </Dialog>
    </Paper>
  );
}

export default ViewCertificate;
